import type { Milestone, MilestoneDependency, Rock, RockUpdate } from './types';

export const rockFromRow = (row: any): Rock => ({
  id: row.id, teamId: row.team_id ?? undefined, goalId: row.goal_id ?? undefined,
  title: row.title, description: row.description ?? undefined, status: row.status as any,
  ownerId: row.owner_id ?? undefined, quarter: row.quarter, year: row.year,
  dueDate: row.due_date ?? undefined, sourceRockId: row.source_rock_id ?? undefined,
  plannedWeight: row.planned_weight ?? undefined, createdAt: row.created_at ?? undefined,
});

export const milestoneDependencyFromRow = (row: any): MilestoneDependency => ({
  id: row.id,
  predecessorId: row.predecessor_id,
  successorId: row.successor_id,
  lagDays: row.lag_days ?? 0,
  type: (row.dependency_type ?? 'fs') as MilestoneDependency['type'],
});

export const rockUpdateFromRow = (row: any): RockUpdate => ({
  id: row.id,
  workspaceId: row.workspace_id,
  rockId: row.rock_id,
  authorId: row.author_id,
  authorMemberId: row.author_member_id ?? undefined,
  message: row.message ?? undefined,
  statusAtUpdate: row.status_at_update,
  isSystemGenerated: row.is_system_generated ?? false,
  editedAt: row.edited_at ?? undefined,
  createdAt: row.created_at,
});

export const milestoneFromRow = (row: any): Milestone => ({
  id: row.id, rockId: row.rock_id, title: row.title, completed: row.completed,
  completedAt: row.completed_at ?? undefined, ownerId: row.owner_id ?? undefined,
  startDate: row.start_date ?? undefined, endDate: row.end_date ?? undefined,
  baselineStart: row.baseline_start ?? undefined, baselineEnd: row.baseline_end ?? undefined,
  weight: row.weight ?? undefined, position: row.position ?? 0,
  sourceMilestoneId: row.source_milestone_id ?? undefined,
});
